export default function PageHeader({ eyebrow, title, description }) {
    return (
        <header className="mb-8">
            <p className="eyebrow">{eyebrow}</p>
            <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                {title}
            </h1>
            {description && (
                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-gray-400 sm:text-base">
                    {description}
                </p>
            )}
        </header>
    );
}
